import * as React from "react";
import { forwardRef } from "react";
const SvgMentionArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.33366 8H12.667", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.00033 12.6693L12.667 8.0026L8.00033 3.33594", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMentionArrowLeft);
export { ForwardRef as ReactComponent };
